import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../store/services/content.service';
import { Router } from '@angular/router';
import { LeftMenuService } from '../../store/services/left-menu.service';
import { IQuickResponse, IVsmCommentResponse } from '../../store/models/content.model';
import { Button, ButtonColor, ButtonSize } from '../../store/models/button.model';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-vsm-comments',
  templateUrl: './vsm-comments.component.html',
  styleUrls: ['./vsm-comments.component.scss'],
})
export class VsmCommentsComponent implements OnInit {
  comments: IVsmCommentResponse[] = [];

  newButtonProperties: Button = {
    text: 'Create',
    color: ButtonColor.ORANGE,
    size: ButtonSize.SMALL,
    onClick: () => this.router.navigate(['contents', 'vsm_comments', 'new']),
  };

  editButtonProperties: Button = {
    size: ButtonSize.SMALL,
    color: ButtonColor.BLUE,
    text: 'Edit',
    onClick: (item: IQuickResponse) =>
      this.router.navigate(['contents', 'vsm_comments', item.id, 'edit']),
  };

  deleteButtonProperties: Button = {
    size: ButtonSize.SMALL,
    color: ButtonColor.RED,
    text: 'Delete',
    onClick: (item: IQuickResponse) =>
      this.store$.dispatch(
        openDialog({
          dialogData: {
            title: 'Delete Edge Comment',
            content: `Are you sure you want to delete "${item.name}"?`,
            canClose: true,
            buttons: [
              {
                text: 'Confirm',
                onClick: (dialog: DialogComponent) =>
                  this.contentService.deleteVsmComment(item.id).subscribe(
                    () => {
                      this.store$.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: 'Edge Comment deleted successfully',
                              type: 'success',
                            },
                          },
                        }),
                      );
                      this.ngOnInit();
                      dialog.closeDialog();
                    },
                    error => {
                      this.store$.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              message: error.error,
                              type: 'error',
                            },
                          },
                        }),
                      );
                      dialog.closeDialog();
                    },
                  ),
                color: ButtonColor.RED,
                size: ButtonSize.NORMAL,
              },
            ],
          },
        }),
      ),
  };

  constructor(
    private readonly contentService: ContentService,
    private readonly router: Router,
    private readonly leftMenuService: LeftMenuService,
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit(): void {
    this.leftMenuService.expand('content');
    this.contentService
      .getVsmComments()
      .subscribe(res => (this.comments = res.items));
  }
}
